"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = _interopRequireDefault(require("D:\\\u9879\u76EE\u7BA1\u7406\\\u65E7\u6362\u65B0\\\u6E90\u7801\\yijiuhuanxin_project_java\\WebPcAdmin\\node_modules\\@babel\\runtime\\regenerator\\index.js"));

var _index2 = _interopRequireDefault(require("@/components/Tinymce/index"));

var _store = require("@/api/store");

var _logistics = require("@/api/logistics");

var _marketing = require("@/api/marketing");

var _creatTemplates = _interopRequireDefault(require("@/views/systemSetting/logistics/shippingTemplates/creatTemplates"));

var _validate = require("@/utils/validate");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var defaultObj = {
  image: '',
  images: [],
  headImg: "",
  title: '',
  ficti: 0,
  unitName: '',
  sort: 0,
  giveIntegral: 0,
  tempId: '',
  attrValue: [{
    image: '',
    price: 0,
    cost: 0,
    otPrice: 0,
    stock: 0,
    quota: 1,
    barCode: '',
    weight: 0,
    volume: 0
  }],
  attr: [],
  selectRule: '',
  descInfo: '',
  specType: false,
  id: 0,
  thirdCatId: '',
  thirdCatIdList: [],
  brandId: 0,
  qualificationPics: '',
  qualificationPicsList: []
};
var objTitle = {
  price: {
    title: '商品价'
  },
  cost: {
    title: '成本价'
  },
  otPrice: {
    title: '原价'
  },
  stock: {
    title: '库存'
  },
  quota: {
    title: "限量"
  },
  barCode: {
    title: '商品编号'
  },
  weight: {
    title: '重量（KG）'
  },
  volume: {
    title: '体积(m³)'
  }
};
var _default = {
  name: "creatSeckill",
  components: {
    CreatTemplates: _creatTemplates.default,
    Tinymce: _index2.default
  },
  data: function data() {
    return {
      props: {
        children: 'secondCatList',
        label: 'secondCatName',
        value: 'secondCatId',
        multiple: true,
        emitPath: false
      },
      propsCatId: {
        emitPath: true
      },
      options: [],
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < new Date().setTime(new Date().getTime() - 3600 * 1000 * 24);
        }
      },
      props2: {
        children: 'child',
        label: 'name',
        value: 'id',
        multiple: true,
        emitPath: false
      },
      grid2: {
        xl: 8,
        lg: 10,
        md: 12,
        sm: 24,
        xs: 24
      },
      currentTab: 0,
      formThead: Object.assign({}, objTitle),
      formValidate: Object.assign({}, defaultObj),
      loading: false,
      fullscreenLoading: false,
      shippingList: [],
      // 运费模板
      ruleValidate: {
        primaryProductId: [{
          required: true,
          message: '请选择商品',
          trigger: 'change'
        }],
        title: [{
          required: true,
          message: '请输入商品标题',
          trigger: 'blur'
        }],
        attrValue: [{
          required: true,
          message: '请选择商品属相',
          trigger: 'change',
          type: 'array',
          min: '1'
        }],
        ficti: [{
          required: true,
          message: '请输入虚拟销量',
          trigger: 'blur'
        }],
        unitName: [{
          required: true,
          message: '请输入单位',
          trigger: 'blur'
        }],
        tempId: [{
          required: true,
          message: '请选择运费模板',
          trigger: 'change'
        }],
        giveIntegral: [{
          required: true,
          message: '请输入获得积分',
          trigger: 'blur'
        }],
        images: [{
          required: true,
          message: '请上传商品轮播图',
          type: 'array',
          trigger: 'change'
        }],
        specType: [{
          required: true,
          message: '请选择商品规格',
          trigger: 'change'
        }],
        thirdCatIdList: [{
          required: true,
          message: '请选择商品类目',
          trigger: 'change'
        }]
      },
      manyTabDate: {},
      manyTabTit: {},
      attrInfo: {},
      tempRoute: {},
      multipleSelection: [],
      primaryProductId: 0,
      productQualificationType: 0,
      //商品资质类型，0不需要，1必填，2选填
      productQualification: '',
      // 资质说明
      OneattrValue: [Object.assign({}, defaultObj.attrValue[0])],
      // 单规格
      ManyAttrValue: [Object.assign({}, defaultObj.attrValue[0])] // 多规格

    };
  },
  computed: {
    attrValue: function attrValue() {
      var obj = Object.assign({}, defaultObj.attrValue[0]);
      delete obj.image;
      return obj;
    }
  },
  created: function created() {
    this.$watch('formValidate.attr', this.watCh);
    this.tempRoute = Object.assign({}, this.$route);
    if (!JSON.parse(sessionStorage.getItem('videoCategory'))) this.getCatList();
  },
  mounted: function mounted() {
    this.formValidate.images = [];

    if (this.$route.params.id) {
      this.setTagsViewTitle();
      this.getInfo();
      this.currentTab = 1;
    }

    this.getShippingList();
    this.options = JSON.parse(sessionStorage.getItem('videoCategory')); //this.options
  },
  methods: {
    handleChanges: function handleChanges(e) {
      var obj = this.$refs['demoCascader'].getCheckedNodes();
      this.productQualificationType = obj[0].data.productQualificationType;
      this.productQualification = obj[0].data.productQualification;
    },
    // 类目；
    getCatList: function getCatList() {
      var _this2 = this;

      (0, _marketing.catListApi)().then(function (res) {
        _this2.options = res;
        sessionStorage.setItem('videoCategory', JSON.stringify(res));
      });
    },
    watCh: function watCh(val) {
      var tmp = {};
      var tmpTab = {};
      this.formValidate.attr.forEach(function (o, i) {
        // tmp['value' + i] = { title: o.attrName }
        // tmpTab['value' + i] = ''
        tmp[o.attrName] = {
          title: o.attrName
        };
        tmpTab[o.attrName] = '';
      });
      this.manyTabTit = tmp;
      this.manyTabDate = tmpTab;
      this.formThead = Object.assign({}, this.formThead, tmp);
    },
    handleRemove: function handleRemove(i, val) {
      if (val === 'images') {
        this.formValidate.images.splice(i, 1);
      } else {
        this.formValidate.qualificationPicsList.splice(i, 1);
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 点击商品图
    modalPicTap: function modalPicTap(tit, num, i) {
      var _this = this;

      if (tit === '3') return this.$message.warning("正在建造");
      this.$modalUpload(function (img) {
        if (tit === '1' && !num) {
          _this.formValidate.image = img[0].sattDir;
          _this.ManyAttrValue[0].image = img[0].sattDir;
        }

        if (tit === '2' && !num) {
          if (img.length > 10 || img.length + _this.formValidate.images.length > 10) return this.$message.warning("最多选择10张图片！");
          img.map(function (item) {
            _this.formValidate.images.push(item.sattDir);
          });
        }

        if (tit === '1' && num === 'duo') {
          _this.ManyAttrValue[i].image = img[0].sattDir;
        }

        if (tit === '3') {
          if (img.length > 10 || img.length + _this.formValidate.qualificationPicsList.length > 10) return this.$message.warning("最多选择10张图片！");
          img.map(function (item) {
            _this.formValidate.qualificationPicsList.push(item.sattDir);
          });
        }
      }, tit, 'content');
    },
    changeGood: function changeGood() {
      var _this = this;

      this.$modalGoodList(function (row) {
        _this.formValidate.image = row.image;
        _this.primaryProductId = row.id; // _this.formValidate.productId = row.id
      });
    },
    handleSubmitNest1: function handleSubmitNest1() {
      if (!this.formValidate.image) {
        return this.$message.warning("请选择商品！");
      } else {
        this.currentTab++;
        if (!this.$route.params.id) this.getProdect(this.primaryProductId);
      }
    },
    filerMerCateList: function filerMerCateList(treeData) {
      return treeData.map(function (item) {
        if (!item.child) {
          item.disabled = true;
        }

        item.label = item.name;
        return item;
      });
    },
    // 运费模板；
    getShippingList: function getShippingList() {
      var _this3 = this;

      (0, _logistics.shippingTemplatesList)(this.tempData).then(function (res) {
        _this3.shippingList = res.list;
      });
    },
    // 运费模板
    addTem: function addTem() {
      this.$refs.addTemplates.dialogVisible = true;
      this.$refs.addTemplates.getCityList();
    },
    // 商品详情
    getInfo: function getInfo() {
      if (!this.$route.params.id) {
        this.getProdect(this.primaryProductId);
      } else {
        this.getDraftProdect(this.$route.params.id);
      }
    },
    getProdect: function getProdect(id) {
      var _this4 = this;

      this.fullscreenLoading = true;
      (0, _store.productDetailApi)(id).then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee(res) {
          var info;
          return _index.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  info = res;
                  _this4.formValidate = {
                    image: _this4.$selfUtil.setDomain(info.image),
                    images: JSON.parse(info.sliderImage),
                    title: info.storeName,
                    quota: '',
                    unitName: info.unitName,
                    sort: info.sort,
                    tempId: info.tempId,
                    attr: info.attr,
                    selectRule: info.selectRule,
                    descInfo: info.content,
                    specType: info.specType,
                    primaryProductId: info.id,
                    giveIntegral: info.giveIntegral,
                    ficti: info.ficti,
                    qualificationPicsList: [],
                    thirdCatIdList: [],
                    thirdCatId: 0,
                    brandId: 2100000000,
                    id: 0
                  };

                  if (info.specType) {
                    info.attrValue.forEach(function (row) {
                      row.quota = row.stock;
                      row.attrValue = JSON.parse(row.attrValue);

                      for (var attrValueKey in row.attrValue) {
                        row[attrValueKey] = row.attrValue[attrValueKey];
                      }
                    });

                    _this4.$nextTick(function () {
                      info.attrValue.forEach(function (row) {
                        row.image = _this4.$selfUtil.setDomain(row.image);

                        _this4.$refs.multipleTable.toggleRowSelection(row, true);

                        _this4.$set(row, 'checked', true);
                      });
                    });

                    _this4.ManyAttrValue = info.attrValue;
                    _this4.multipleSelection = info.attrValue;
                  } else {
                    info.attrValue.forEach(function (row) {
                      row.quota = row.stock;
                    });
                    _this4.ManyAttrValue = info.attrValue;
                    _this4.formValidate.attr = [];
                  }

                  _this4.fullscreenLoading = false;

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this4.fullscreenLoading = false;
      });
    },
    getDraftProdect: function getDraftProdect(id) {
      var _this5 = this;

      this.fullscreenLoading = true;
      (0, _marketing.draftInfoApi)(id).then( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee2(res) {
          var info;
          return _index.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  info = res;
                  _this5.formValidate = {
                    images: JSON.parse(info.headImg),
                    title: info.title,
                    // quota: info.quota,
                    unitName: info.unitName,
                    // sort: info.sort,
                    tempId: info.tempId,
                    attr: JSON.parse(info.attr),
                    // selectRule: info.selectRule,
                    descInfo: info.descInfo,
                    specType: info.specType,
                    primaryProductId: info.primaryProductId,
                    giveIntegral: info.giveIntegral,
                    ficti: info.ficti,
                    thirdCatIdList: [info.catInfo.firstCatId, info.catInfo.secondCatId, info.catInfo.thirdCatId],
                    thirdCatId: info.thirdCatId,
                    brandId: info.brandId,
                    qualificationPicsList: JSON.parse(info.qualificationPics) || [],
                    id: info.productId
                  };

                  if (info.specType) {
                    _this5.ManyAttrValue = JSON.parse(info.attrValue);

                    _this5.$nextTick(function () {
                      _this5.ManyAttrValue.forEach(function (item, index) {
                        item.attrValue = JSON.parse(item.attrValue);

                        for (var attrValueKey in item.attrValue) {
                          item[attrValueKey] = item.attrValue[attrValueKey];
                        }

                        if (item.id) {
                          _this5.$set(item, 'price', item.price);

                          _this5.$set(item, 'quota', item.quota);

                          _this5.$nextTick(function () {
                            _this5.$refs.multipleTable.toggleRowSelection(item, true);
                          });
                        }
                      });
                    });
                  } else {
                    _this5.ManyAttrValue = JSON.parse(info.attrValue);
                    _this5.formValidate.attr = [];
                  }

                  _this5.fullscreenLoading = false;

                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this5.fullscreenLoading = false;
      });
    },
    handleSubmitNest2: function handleSubmitNest2(name) {
      var _this6 = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          if (_this6.formValidate.specType && _this6.multipleSelection.length === 0) return _this6.$message.warning("请填选择至少一个商品属性！");
          if (_this6.productQualificationType === 1 && _this6.formValidate.qualificationPicsList.length === 0) return _this6.$message.warning("该类目必须上传商品资质图片，请上传！");
          _this6.currentTab++;
        } else {
          return false;
        }
      });
    },
    // 提交
    handleSubmit: (0, _validate.Debounce)(function (name) {
      var _this7 = this;

      if (!this.formValidate.specType) {
        // this.formValidate.attr = []
        this.formValidate.attrValue = this.ManyAttrValue;
      } else {
        // this.multipleSelection.forEach((row) => {
        //   this.$set(row, 'checked', true)
        // });
        this.formValidate.attrValue = this.multipleSelection;
        this.formValidate.attrValue.forEach(function (item) {
          item.attrValue = JSON.stringify(item.attrValue);
        });
      }

      this.formValidate.thirdCatId = this.formValidate.thirdCatIdList[2];
      this.formValidate.headImg = JSON.stringify(this.formValidate.images);
      this.formValidate.qualificationPics = JSON.stringify(this.formValidate.qualificationPicsList);
      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this7.fullscreenLoading = true;
          _this7.loading = true;
          _this7.$route.params.id ? (0, _marketing.draftUpdateApi)(_this7.formValidate).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee3() {
            return _index.default.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _this7.fullscreenLoading = false;

                    _this7.$message.success('编辑成功');

                    _this7.$router.push({
                      path: "/marketing/videoChannel/draftList"
                    });

                    _this7.$refs[name].resetFields();

                    _this7.formValidate.images = [];
                    _this7.formValidate.qualificationPics = [];
                    _this7.loading = false;

                  case 7:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }))).catch(function () {
            _this7.fullscreenLoading = false;
            _this7.loading = false;
          }) : (0, _marketing.videoAddApi)(_this7.formValidate).then( /*#__PURE__*/function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee4(res) {
              return _index.default.wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      _this7.fullscreenLoading = false;

                      _this7.$message.success('新增成功');

                      _this7.$router.push({
                        path: "/marketing/videoChannel/draftList"
                      });

                      _this7.$refs[name].resetFields();

                      _this7.formValidate.images = [];
                      _this7.formValidate.qualificationPics = [];
                      _this7.loading = false;

                    case 7:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _callee4);
            }));

            return function (_x3) {
              return _ref4.apply(this, arguments);
            };
          }()).catch(function () {
            _this7.fullscreenLoading = false;
            _this7.loading = false;
          });
        } else {
          if (!_this7.formValidate.storeName || !_this7.formValidate.unitName || !_this7.formValidate.store_info || !_this7.formValidate.image || !_this7.formValidate.images) {
            _this7.$message.warning("请填写完整商品信息！");
          }
        }
      });
    }),
    handleSubmitUp: function handleSubmitUp() {
      this.productQualificationType = 0;
      this.formValidate.thirdCatIdList = [];
      if (this.currentTab-- < 0) this.currentTab = 0;
    },
    setTagsViewTitle: function setTagsViewTitle() {
      var title = '编辑视频号商品';
      var route = Object.assign({}, this.tempRoute, {
        title: "".concat(title, "-").concat(this.$route.params.id)
      });
      this.$store.dispatch('tagsView/updateVisitedView', route);
    },
    // 移动
    handleDragStart: function handleDragStart(e, item) {
      this.dragging = item;
    },
    handleDragEnd: function handleDragEnd(e, item) {
      this.dragging = null;
    },
    handleDragOver: function handleDragOver(e) {
      e.dataTransfer.dropEffect = 'move';
    },
    handleDragEnter: function handleDragEnter(e, item, val) {
      var _newItems;

      e.dataTransfer.effectAllowed = 'move';

      if (item === this.dragging) {
        return;
      }

      var newItems = [];

      if (val === 'images') {
        newItems = _toConsumableArray(this.formValidate.images);
      } else {
        newItems = _toConsumableArray(this.formValidate.qualificationPicsList);
      }

      var src = newItems.indexOf(this.dragging);
      var dst = newItems.indexOf(item);

      (_newItems = newItems).splice.apply(_newItems, [dst, 0].concat(_toConsumableArray(newItems.splice(src, 1))));

      if (val === 'images') {
        this.formValidate.images = newItems;
      } else {
        this.formValidate.qualificationPicsList = newItems;
      }
    }
  }
};
exports.default = _default;